import { FormattedMessage } from 'react-intl';
import { uniq } from 'lodash';

// MUI
import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

// common
import useGeneralHook from 'common/hook/useGeneralHook';
import { DEFAULT_PAGESIZE } from 'common/constants';

export interface NewPaginationProps {
  page?: number;
  rowsPerPage?: number;
  rowsPerPageOptions?: number[];
  onPageChange: (value: number) => void;
  onRowsPerPageChange: (value) => void;
  boxProps?: BoxProps;
}

interface Props extends NewPaginationProps {
  count: number;
}

const NewPagination = (props: Props) => {
  const {
    boxProps,
    count,
    page,
    rowsPerPage = DEFAULT_PAGESIZE,
    rowsPerPageOptions = [20, 50, 75, 100],
    onPageChange,
    onRowsPerPageChange,
  } = props;

  const { isMobile } = useGeneralHook();

  return (
    <Box
      className="px-2 py-1 tablet:px-4 tablet:py-2 flex flex-row items-center tablet:flex-col tablet:items-stretch pr-10 tablet:pr-0"
      {...boxProps}
    >
      <Typography variant="caption" component={'div'} className="flex items-center gap-2">
        {!isMobile && <FormattedMessage id="display" />}
        <FormControl fullWidth sx={{ width: 70, height: 24, paddingTop: 0 }}>
          <Select
            sx={{ height: 24, paddingTop: 0.5 }}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
            fullWidth
            variant="outlined"
            size="medium"
            value={rowsPerPage}
            onChange={(event) => onRowsPerPageChange(event.target.value)}
          >
            {uniq([...rowsPerPageOptions, rowsPerPage])
              .map((item) => ({
                id: item,
                name: item,
              }))
              .sort((a, b) => a.id - b.id)
              .map((item) => (
                <MenuItem key={item.id} value={item.id} sx={{ height: 24, paddingTop: 4 }}>
                  {item.id}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        {!isMobile && <FormattedMessage id="of_result" values={{ num: count }} />}
      </Typography>
      <Box className="flex justify-center mt-2 flex-1">
        <Pagination
          showFirstButton
          showLastButton
          page={page}
          count={Math.ceil(count / rowsPerPage)}
          onChange={(_e, page) => {
            onPageChange(page);
          }}
          variant="outlined"
          shape="rounded"
          size={isMobile ? 'small' : 'medium'}
          sx={{
            '& .MuiPaginationItem-root.Mui-selected': {
              color: '#fff',
              background: '#E41E26',
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default NewPagination;
